import Error from '../model/Error';
import MealPlan from '../dto/MealPlan';
import axios from 'axios';

export default class MealPlanRepository {
    static addFiles(dietId, files) {
        const calls = files.map((file) => {
            const config = {
                headers: { 'Content-Type': 'application/octet-stream', 'X-File-Title': file.title },
            };
            return axios.put(`/meal-plans/${dietId}/files`, file.data, config);
        });

        return new Promise((resolve, reject) => {
            axios.all(calls)
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static removeFile(member) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/members/${member.id}/avatar`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByKindergarten(kindergartenId, params) {
        return new Promise((resolve, reject) => {
            params.start = params.start.subDays(7); // fetch one week earlier
            axios
                .get(`/kindergartens/${kindergartenId}/meal-plans`, { params: { range: `${params.start.toIso8601()}:${params.end.toIso8601()}` } })
                .then((response) => resolve(response.data.data.map((data) => MealPlan.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(mealPlan) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/meal-plans/${mealPlan.id}`, mealPlan.serialize())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static add(kindergartenId, mealPlan) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/kindergartens/${kindergartenId}/meal-plans`, mealPlan.serialize())
                .then((response) => resolve(Number.parseInt(response.headers['x-identifier'])))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
